"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
const detect_browser_1 = require("detect-browser");
const mobile_device_detect_1 = require("mobile-device-detect");
class System {
    static Browser() {
        return (0, detect_browser_1.detect)();
    }
    static IsBrowserSupported() {
        const browser = (0, detect_browser_1.detect)();
        const version = parseInt(browser.version.substring(0, browser.version.indexOf('.')));
        return (((browser.name === 'chrome' && version >= 76) ||
            (browser.name === 'edge-chromium' && version >= 76) ||
            (browser.name === 'crios' && version >= 76) ||
            (browser.name === 'safari' && version >= 12) ||
            (browser.name === 'ios' && version >= 12) ||
            (browser.name == 'firefox' && !mobile_device_detect_1.isMobile && version >= 76)) &&
            this.IsWebRTCAvailable());
    }
    static IsWebRTCAvailable() {
        return window.RTCPeerConnection !== undefined && window.RTCDataChannel !== undefined;
    }
}
exports.System = System;
